import { useQuery } from 'react-query';
import { useAxiosClient } from '../utils/useAxiosClient';
import { useFilterSetData } from './useFilterSetData';

export interface Brand {
  id: string;  // Changed to string since we're using brandname as ID
  name: string;
}

export interface OrganizationMetadata {
  data_start_date?: string;
  data_end_date?: string | null;
  organization_name?: string;
  dashboard_type?: string;
}

export const useOrganizationMetadata = (orgId: number) => {
  const axiosClient = useAxiosClient();
  
  const { data: metadata, isLoading, error } = useQuery<OrganizationMetadata>(
    ['organizationMetadata', orgId],
    async () => {
      if (!orgId) return null;
      const response = await axiosClient.get(`/api/organization-metadata?org=${orgId}`);
      return response.data;
    },
    {
      enabled: !!orgId,
      staleTime: 60 * 60 * 1000, // 1 hour
      retry: 1,
      refetchOnWindowFocus: false
    }
  );

  return {
    metadata,
    loading: isLoading,
    error: error ? (error instanceof Error ? error.message : 'An error occurred') : null
  };
};

export const useDashboardType = (orgId: number) => {
  const { metadata, loading, error } = useOrganizationMetadata(orgId);
  
  return {
    dashboardType: metadata?.dashboard_type || 'standard', // Default to 'standard' if not specified
    loading,
    error
  };
};

export const useBrands = (orgId: number) => {
  const { filterSetData, loading, error } = useFilterSetData(orgId);

  return {
    brands: filterSetData?.brands || [],
    loading,
    error
  };
}; 